// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-counter{background:red}.test-counter p{font-weight:bold}`, "",{"version":3,"sources":["webpack://./widgets/mtt-react-counter/js/Counter.scss"],"names":[],"mappings":"AAAA,cACE,cAAA,CAEA,gBACE,gBAAA","sourcesContent":[".test-counter {\n  background: red;\n\n  p {\n    font-weight: bold;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
